<template>
  <nav>
    <ul class="nav-links">
      <navigation-link
        v-for="(section, index) in sections"
        :key="section.id"
        :section="section"
        :active="isActive(section.id)"
        :visited="isAboveActive(index)"
        @select="select($event)"
      />
    </ul>
  </nav>
</template>

<script>
import NavigationLink from './NavigationLink.vue'

export default {
  name: 'navigation',
  components: {
    'navigation-link': NavigationLink
  },
  props: {
    sections: Array,
    active: String,
    visited: Array
  },
  computed: {
    activeIndex() {
      return this.sections.findIndex((c) => c.id === this.active)
    }
  },
  methods: {
    isActive(id) {
      return this.active === id
    },
    isAboveActive(index) {
      return index <= this.activeIndex
    },
    hasBeenVisited(id) {
      return this.visited.indexOf(id) > -1
    },
    select(e) {
      this.$emit('select', e)
    }
  }
}
</script>

<style scoped lang="scss">
/** navigation list **/
@import '../../theme';
@import './_variables';

ul {
  padding: 0;
}

.nav-links {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 $nav-padding;
}

</style>
